/* eslint-disable camelcase */
import { gql } from '@apollo/client'

export type { CreateLots, CreateLotsVariables } from './types/index.graphql'
export type { UpdateLots, UpdateLotsVariables } from './types/index.graphql'
export type {
  MapLots,
  MapLotsVariables,
  CreateLots_createLots_LotsV2_results_LotV2 as Lot,
} from './types/index.graphql'

export const CREATE_LOTS = gql`
  mutation CreateLots($createLotDTOs: [CreateLotInput!]!) {
    createLots(createLotDTOs: $createLotDTOs) {
      results {
        id
        name
        commercialName
        riceLot {
          id
          isPlanetEnabled
        }
        area {
          type
          coordinates
        }
        location {
          type
          coordinates
        }
        size
        crop {
          id
        }
        variety {
          id
          name
          locales {
            es
            en
            pt
          }
        }
      }
    }
  }
`

export const UPDATE_LOTS = gql`
  mutation UpdateLots($updateLotDTOs: [UpdateLotInput!]!) {
    updateLots(updateLotDTOs: $updateLotDTOs) {
      results {
        id
        name
        commercialName
        area {
          type
          coordinates
        }
        location {
          type
          coordinates
        }
        size
        crop {
          id
        }
        variety {
          id
          name
          locales {
            es
            en
            pt
          }
        }
      }
    }
  }
`

export const MAP_LOTS = gql`
  query MapLots($seasonId: Int!, $fieldId: Int!) {
    lotsV2(seasonId: $seasonId, fieldId: $fieldId) {
      results {
        id
        name
        commercialName
        size
        riceLot {
          id
          isPlanetEnabled
        }
        area {
          type
          coordinates
        }
        location {
          coordinates
          type
        }
        crop {
          id
        }
        variety {
          id
          name
          locales {
            es
            en
            pt
          }
        }
      }
    }
  }
`
